import React, { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Pagination,
} from '@mui/material'

import { SmartPayRecord } from 'types'

import { RecordItem } from './RecordItem'

interface RecordListProps {
  records: SmartPayRecord[]
  title: string
  icon: React.ReactNode
  color: string
}

const PAGE_SIZE = 5

export const RecordList = ({ records, title, icon, color }: RecordListProps) => {
  const [page, setPage] = useState(1)
  if (records.length === 0) return null

  const pageCount = Math.ceil(records.length / PAGE_SIZE)
  const paginatedRecords = records.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  return (
    <Accordion defaultExpanded={records.length > 0 && records.length < 20}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {icon}
          <Typography variant='subtitle1'>
            {title} ({records.length})
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
          {paginatedRecords.map((record, index) => (
            <RecordItem key={index + (page - 1) * PAGE_SIZE} record={record} color={color} />
          ))}
        </Box>
        {pageCount > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Pagination
              count={pageCount}
              page={page}
              onChange={(_, value) => setPage(value)}
              size='small'
            />
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  )
}
